import { RTC_PROVIDERS } from '../../providerIds'
import { createHundredMsRtcPortBundle } from './createHundredMsRtcPortBundle'
import {
  createHundredMsRtcAdapterCapabilities,
  createHundredMsRtcCompatibilityProps,
  HundredMsRtcCompatibilitySurface,
  preloadHundredMsRtcModule,
} from './hundredMsRtcCompat'
import {
  HUNDRED_MS_RTC_SESSION_EVENTS,
  createHundredMsRtcSessionHandle,
} from './createHundredMsRtcSessionHandle'

export { HUNDRED_MS_RTC_SESSION_EVENTS } from './createHundredMsRtcSessionHandle'
export { createHundredMsRtcSessionHandle } from './createHundredMsRtcSessionHandle'

export function createHundredMsRtcAdapter({ capabilityOverrides = {} } = {}) {
  return {
    id: RTC_PROVIDERS.hundredMs,
    domain: 'rtc',
    compatibilityBridge: '100ms-react-sdk',
    supports: createHundredMsRtcAdapterCapabilities(capabilityOverrides),
    preload: preloadHundredMsRtcModule,
    CompatibilitySurface: HundredMsRtcCompatibilitySurface,
    createCompatibilityProps: createHundredMsRtcCompatibilityProps,
    createSession(initialConfig = {}) {
      return createHundredMsRtcSessionHandle({
        initialConfig,
      })
    },
    createPortBundle(options = {}) {
      return createHundredMsRtcPortBundle(options)
    },
  }
}

export const hundredMsRtcAdapter = createHundredMsRtcAdapter()
